import API from './api';
import { Project, Image, ProjectImage, SlideshowLang, ProjectWithSlideCount, OutlineNode, ProjectCreate, SlideshowRecommendation, RecommendationRequest, DocxRecommendationRequest, ProjectUpdate } from '../types';

export const getProjects = async (tagIds?: string[]): Promise<ProjectWithSlideCount[]> => {
  const params: any = {};
  if (tagIds && tagIds.length > 0) {
    params.tagIds = tagIds.join(',');
  }
  const response = await API().get('/projects', { params });
  return response.data;
};

export const getProjectById = async (id: string): Promise<Project> => {
  const response = await API().get(`/projects/${id}`);
  return response.data;
};

export const createProject = async (projectData: ProjectCreate): Promise<Project> => {
  const response = await API().post('/projects', projectData);
  return response.data;
};

export const updateProject = async (id: string, projectData: ProjectUpdate): Promise<Project> => {
  const response = await API().put(`/projects/${id}`, projectData);
  return response.data;
};

export const deleteProject = async (id: string, hard: boolean = false): Promise<void> => {
  await API().delete(`/projects/${id}`, { params: { hard } });
};

export const deleteFact = async (projectId: string, factId: string): Promise<void> => {
  await API().delete(`/projects/${projectId}/facts/${factId}`);
};

export const getProjectImages = async (projectId: string): Promise<Image[]> => {
  const response = await API().get(`/projects/${projectId}/images`);
  return response.data;
};

export const updateProjectImage = async (projectId: string, imageId: string, imageData: Partial<ProjectImage>): Promise<ProjectImage> => {
  const response = await API().put(`/projects/${projectId}/images/${imageId}`, imageData);
  return response.data;
};

export const associateImageWithProject = async (projectId: string, imageId: string, projectImageData: Partial<ProjectImage>): Promise<void> => {
  await API().post(`/projects/${projectId}/images/${imageId}`, projectImageData);
};

export const dissociateImageFromProject = async (projectId: string, imageId: string): Promise<void> => {
  await API().delete(`/projects/${projectId}/images/${imageId}`);
};

export const exportProjectAsPPTX = async (projectId: string): Promise<Blob> => {
  const response = await API().get(`/projects/${projectId}/export`, { responseType: 'blob' });
  return response.data;
};

export const recommendSlideshow = async (request: RecommendationRequest | DocxRecommendationRequest, lang: SlideshowLang): Promise<SlideshowRecommendation> => {
  const response = await API().post('/projects/recommend-slideshow', { ...request, lang });
  return response.data;
};
